import styles from "./ClientEntryFomr.module.css";
import Button from "../utilities/button/Button.js";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CountryOptions from "../potential-client/CountryOptions.js";

function ClientEntryForm() {
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [instagram, setInstagram] = useState("");
  const [facebook, setFacebook] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [contactperson, setcontactperson] = useState("");
  const [businesscategory, setbusinesscategory] = useState("");

  // INPUT STATE
  const [inputStatus, setInputStatus] = useState(false);
  const [btnStatus, setBtnStatus] = useState("Create");

  // EMAIL VALIDATE
  const [emailValidate, setEmailValidate] = useState("");
  const [emailValidateColor, setEmailValidateColor] = useState(false);

  // COUNTRY STATE
  const [countryApi, setCountryApi] = useState([]);

  // CLIENT ALREADY EXIST IN DATA
  const [clientExist, setClientExist] = useState("");

  // ROUTER-DOM NAVIGATE
  const navigate = useNavigate();

  function companyHandler(e) {
    setCompanyName(e.target.value);
  }

  function addressHandler(e) {
    setAddress(e.target.value);
  }

  function countryHandler(e) {
    setCountry(e.target.value);
  }

  function contactHandler(e) {
    setContact(e.target.value);
  }

  function emailHandler(e) {
    setEmail(e.target.value);
  }

  function websiteHandler(e) {
    setWebsite(e.target.value);
  }

  function instagramHandler(e) {
    setInstagram(e.target.value);
  }

  function facebookHandler(e) {
    setFacebook(e.target.value);
  }

  function linkedinHandler(e) {
    setLinkedin(e.target.value);
  }

  function contactPersonHandler(e) {
    setcontactperson(e.target.value);
  }

  function businessCategoryHandler(e) {
    setbusinesscategory(e.target.value);
  }

  // COUNTRY LIST
  useEffect(() => {
    async function getData() {
      const response = await fetch(
        `https://countriesnow.space/api/v0.1/countries/positions`
      );
      const data = await response.json();

      setCountryApi(data.data);
    }

    getData();
  }, []);

  // FORM SUBMISSION
  async function FomrSubmitHandler(e) {
    e.preventDefault();
    setInputStatus(true);
    setBtnStatus("Creating...");

    try {
      const result = await fetch(
        "https://artmadein-dashboard-backend.onrender.com/api/v1/client/createclient",
        // `http://localhost:5000/api/v1/client/createclient`,
        {
          method: "POST",
          credentials: "include",
          body: JSON.stringify({
            companyName,
            address,
            country,
            contact,
            email,
            website,
            instagram,
            facebook,
            linkedin,
            contactperson,
            businesscategory,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (result.status === 409) {
        setInputStatus(false);
        setBtnStatus("Create");
        setClientExist("Client Already Exist");
      }
      if (result.ok) {
        setInputStatus(false);
        setBtnStatus("Create");
        navigate("/client/potentialclient");
      }
    } catch (err) {
      console.log(err);
    }
  }

  // Email Validator
  async function ValidateHandler(e) {
    e.preventDefault();
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/client/checkmx`,
        // `http://localhost:5000/api/v1/client/checkmx`,
        {
          method: "POST",
          body: JSON.stringify({ email }),
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (result.status === 200) {
        setEmailValidateColor(true);
      } else if (result.status >= 400) {
        setEmailValidateColor(false);
      }
      console.log(result.status);
      const message = await result.json();
      setEmailValidate(message.message);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.box}>
          <h1 className={styles.heading}> Client Entry Form</h1>
          <form onSubmit={FomrSubmitHandler}>
            <div className={styles.inputBox}>
              <label htmlFor="companyname">Company Name</label>
              <input
                className={styles.input}
                type="text"
                name="companyname"
                placeholder="Company Name"
                value={companyName}
                onChange={companyHandler}
                disabled={inputStatus}
              ></input>
              {companyName.length <= 0 ? (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Can't be Blank
                </span>
              ) : (
                ""
              )}
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="address">Address</label>
              <input
                className={styles.input}
                type="text"
                name="address"
                placeholder="Address"
                value={address}
                onChange={addressHandler}
                disabled={inputStatus}
              ></input>
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="country">Country</label>
              <select
                className={styles.select}
                onChange={countryHandler}
                value={country}
              >
                <option value={""}>Select the Country</option>
                {countryApi.map((data, index) => {
                  return (
                    <CountryOptions
                      key={index}
                      country={data.name}
                    ></CountryOptions>
                  );
                })}
              </select>
              <br></br>
              {country.length <= 0 ? (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Can't be Blank
                </span>
              ) : (
                ""
              )}
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="contact">contact</label>
              <input
                className={styles.input}
                type="text"
                name="contact"
                placeholder="contact"
                value={contact}
                onChange={contactHandler}
                disabled={inputStatus}
              ></input>
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="email">email</label>
              <input
                className={styles.input}
                type="text"
                name="email"
                placeholder="email"
                value={email}
                onChange={emailHandler}
                disabled={inputStatus}
              ></input>
              <p style={{ marginBottom: "10px" }}>
                {email.length <= 0 ? (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Can't be Blank
                  </span>
                ) : (
                  ""
                )}
              </p>
              <Button
                disabled={email.length <= 0}
                handleClick={ValidateHandler}
              >
                Email Validate
              </Button>
              <span
                className={
                  emailValidateColor
                    ? `${styles.validatetrue}`
                    : `${styles.validatefalse}`
                }
              >
                {emailValidate}
              </span>
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="website">website</label>
              <input
                className={styles.input}
                type="text"
                name="website"
                placeholder="website"
                value={website}
                onChange={websiteHandler}
                disabled={inputStatus}
              ></input>
              {website.length <= 0 ? (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Can't be Blank
                </span>
              ) : (
                ""
              )}
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="instagram">instagram</label>
              <input
                className={styles.input}
                type="text"
                name="instagram"
                placeholder="instagram"
                value={instagram}
                onChange={instagramHandler}
                disabled={inputStatus}
              ></input>
              {instagram.length <= 0 ? (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Can't be Blank
                </span>
              ) : (
                ""
              )}
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="facebook">facebook</label>
              <input
                className={styles.input}
                type="text"
                name="facebook"
                placeholder="facebook"
                value={facebook}
                onChange={facebookHandler}
                disabled={inputStatus}
              ></input>
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="linkedin">linkedin</label>
              <input
                className={styles.input}
                type="text"
                name="linkedin"
                placeholder="linkedin"
                value={linkedin}
                onChange={linkedinHandler}
                disabled={inputStatus}
              ></input>
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="contactperson">Contact Person</label>
              <input
                className={styles.input}
                type="text"
                name="contactperson"
                placeholder="contact person"
                value={contactperson}
                onChange={contactPersonHandler}
                disabled={inputStatus}
              ></input>
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="businesscategory">Business Category</label>
              <input
                className={styles.input}
                type="text"
                name="businesscategory"
                placeholder="business category"
                value={businesscategory}
                onChange={businessCategoryHandler}
                disabled={inputStatus}
              ></input>
              {businesscategory.length <= 0 ? (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Can't be Blank
                </span>
              ) : (
                ""
              )}
            </div>
            <Button
              disabled={
                inputStatus ||
                companyName.length === 0 ||
                country.length === 0 ||
                email.length === 0 ||
                website.length === 0 ||
                instagram.length === 0 ||
                businesscategory.length === 0
              }
            >
              {btnStatus}
            </Button>
          </form>
          <p style={{ color: "red" }}>{clientExist}</p>
        </div>
      </div>
    </>
  );
}

export default ClientEntryForm;
